import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export const LEAD_FIELDS = [
  { value: '__skip__', label: '— skip —' },
  { value: 'first_name', label: 'First name' },
  { value: 'last_name', label: 'Last name' },
  { value: 'email', label: 'Email' },
  { value: 'linkedin_profile_url', label: 'LinkedIn URL' },
  { value: 'current_title', label: 'Job title' },
  { value: 'current_company', label: 'Company' },
  { value: 'headline', label: 'Headline' },
  { value: 'location', label: 'Location' },
  { value: 'industry', label: 'Industry' },
  { value: 'phone', label: 'Phone' },
  { value: 'summary', label: 'Summary' },
]

interface ColumnMappingStepProps {
  fileColumns: string[]
  previewRows: Record<string, string>[]
  mappings: Record<string, string>
  onChange: (fileColumn: string, leadField: string) => void
}

export function ColumnMappingStep({
  fileColumns,
  previewRows,
  mappings,
  onChange,
}: ColumnMappingStepProps) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Map each column from your file to a lead field. Columns set to "skip" are ignored.
      </p>
      <div className="overflow-x-auto rounded-md border">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/50">
              <th className="px-3 py-2 text-left font-medium text-muted-foreground w-40">
                File column
              </th>
              <th className="px-3 py-2 text-left font-medium text-muted-foreground w-44">
                Maps to
              </th>
              {previewRows.slice(0, 3).map((_, i) => (
                <th
                  key={i}
                  className="px-3 py-2 text-left font-medium text-muted-foreground"
                >
                  Row {i + 1}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fileColumns.map((col) => (
              <tr key={col} className="border-b last:border-0">
                <td className="px-3 py-2 font-mono text-xs text-foreground">{col}</td>
                <td className="px-3 py-2">
                  <Select
                    value={mappings[col] ?? '__skip__'}
                    onValueChange={(val) => onChange(col, val)}
                  >
                    <SelectTrigger className="h-7 text-xs w-44">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {LEAD_FIELDS.map((f) => (
                        <SelectItem key={f.value} value={f.value} className="text-xs">
                          {f.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </td>
                {previewRows.slice(0, 3).map((row, i) => (
                  <td key={i} className="px-3 py-2 text-xs text-muted-foreground truncate max-w-[140px]">
                    {row[col] ?? ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
